<script setup lang="ts">
import { useLocaleStore } from '@/store/modules/locale'
// import { useWindowSize } from '@vueuse/core'
// import { useAppStore } from '@/store/modules/app'
// import { setCssVar } from '@/utils'
// import { useDesign } from '@/hooks/web/useDesign'

// const { variables } = useDesign()

// const appStore = useAppStore()

// provide('configGlobal', props)

// 初始化所有主题色
// onMounted(() => {
//   // appStore.setCssVarTheme()
// })

// const { width } = useWindowSize()



// 多语言相关
const localeStore = useLocaleStore()

const currentLocale = computed(() => localeStore.currentLocale)
</script>

<template>
  <ElConfigProvider
    :locale="currentLocale.elLocale"
  >
    <slot></slot>
  </ElConfigProvider>
</template>
